<div *ngIf="user" class="user-trigger" matButton [matMenuTriggerFor]="menu">
  <div
    class="avatar-circle"
    style="background-color: #c3002f; font-weight: 400"
  >
    <ng-container>
      {{ user.displayName?.charAt(0)?.toUpperCase() || "?" }}
    </ng-container>
  </div>
  <div class="menu-link hide-in-phone">Welcome, {{ firstWord }}</div>
</div>
<mat-menu #menu="matMenu">
  <div
    mat-menu-item
    class="drop-menu-item"
    style="color: #727272; font-size: 16px"
  >
    <div>{{ user?.displayName }}</div>
    <div>{{ user?.email }}</div>
  </div>
  <ng-container *ngIf="userData$ | async as data">
    <div
      mat-menu-item
      class="credits-display"
      [matTooltip]="'Current Balance: ' + (data?.credits | number: '1.1-3')"
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        "
      >
        <div style="display: flex; align-items: center; gap: 8px">
          <mat-icon
            style="color: #f44336; font-size: 20px; width: 20px; height: 20px"
          >
            auto_awesome
          </mat-icon>
          <span style="font-weight: 500; color: #555">Credits</span>
        </div>
        <span
          style="
            font-family: &quot;Roboto Mono&quot;, monospace;
            font-weight: 600;
            color: #2e7d32;
          "
        >
          {{ data?.credits | number: "1.1-3" }}
        </span>
      </div>
    </div>
  </ng-container>
  <button
    class="drop-menu-item"
    mat-menu-item
    (click)="goToSettings('billing')"
  >
    <mat-icon color="primary">payments</mat-icon> Buy Credits
  </button>
  <button class="drop-menu-item" mat-menu-item (click)="goToSettings('orders')">
    <mat-icon color="primary">shopping_cart</mat-icon> Orders
  </button>
  <button class="drop-menu-item" mat-menu-item (click)="goToRequests()">
    <mat-icon color="primary">engineering</mat-icon> My requests
  </button>
  <button
    class="drop-menu-item"
    mat-menu-item
    (click)="goToSettings('support')"
  >
    <mat-icon color="primary">support_agent</mat-icon> Support
  </button>
  <button
    class="drop-menu-item"
    mat-menu-item
    (click)="goToSettings('feedback')"
  >
    <mat-icon color="primary">feedback</mat-icon> Submit Feedback
  </button>
  <button class="drop-menu-item" mat-menu-item (click)="snackMsg()">
    <mat-icon color="primary">contrast</mat-icon> Appearance
  </button>
  <button
    class="drop-menu-item"
    mat-menu-item
    (click)="goToSettings('profile')"
  >
    <mat-icon color="primary">account_box</mat-icon> Manage Profile
  </button>
  <mat-divider></mat-divider>
  <button (click)="logout()" class="drop-menu-item" mat-menu-item>
    <mat-icon color="warn">logout</mat-icon> Logout
  </button>
</mat-menu>